/**
 * Hierarchical Category Filter - Subcategory Toggle
 * 
 * This script handles the show/hide behavior of subcategories
 * when their parent main category is selected.
 * 
 * Parent-child relationships are now defined in Liquid via metaobjects,
 * so we read data-parent-gid attributes from the DOM.
 */

(function() {
  'use strict';

  /**
   * Updates the visibility of subcategories based on selected main categories
   */
  function updateSubcategoryVisibility() {
    // Get all main category checkboxes
    const mainCategoryCheckboxes = document.querySelectorAll(
      'input[name="filter.p.m.custom.main_category"]'
    );
    
    // Collect GIDs of all checked main categories
    const checkedMainGids = new Set();
    mainCategoryCheckboxes.forEach(function(checkbox) {
      if (checkbox.checked) {
        checkedMainGids.add(checkbox.value);
      }
    });

    // Show/hide submenu containers based on whether their parent is checked
    const submenuContainers = document.querySelectorAll('.filters-submenu');
    submenuContainers.forEach(function(submenu) {
      const parentGid = submenu.dataset.parentGid;
      
      if (checkedMainGids.has(parentGid)) {
        submenu.classList.add('xo-active');
      } else {
        submenu.classList.remove('xo-active');
      }
    });
  }

  /**
   * Initialize the filter functionality
   */
  function init() {
    // Update visibility on page load
    updateSubcategoryVisibility();

    // Listen for changes on main category checkboxes
    const mainCategoryCheckboxes = document.querySelectorAll(
      'input[name="filter.p.m.custom.main_category"]'
    );
    
    mainCategoryCheckboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function(event) {
        // Enforce single selection: if checking this box, uncheck all others
        if (event.target.checked) {
            mainCategoryCheckboxes.forEach(function(other) {
                if (other !== event.target && other.checked) {
                    other.checked = false;
                }
            });
        }
        
        updateSubcategoryVisibility();
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize after AJAX filter updates (for Shopify filter system)
  document.addEventListener('shopify:filters:update', init);
})();
